"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _api = require("@react-google-maps/api");
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../../../utils/constants");
var _useQuestionSelectionActions = require("../../../hooks/questionnaire/useQuestionSelectionActions");
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _services = require("../../../services");
var _logger = require("../../../services/logger");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const googleMapsLibraries = ['places'];
function SearchByMap(_ref) {
  var _apiConfig$credential;
  let {
    question,
    selections,
    preselectedAddress,
    id
  } = _ref;
  const tenant = (0, _useConfig.default)('tenant');
  const apiConfig = (0, _useConfig.default)('api');
  const {
    isLoaded
  } = (0, _api.useJsApiLoader)({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || (apiConfig === null || apiConfig === void 0 ? void 0 : (_apiConfig$credential = apiConfig.credentials) === null || _apiConfig$credential === void 0 ? void 0 : _apiConfig$credential.googleApiKey),
    libraries: googleMapsLibraries,
    ..._constants.GOOGLE_MAPS_LOCALS[tenant]
  });
  const searchBoxRef = _react.default.useRef();
  const [selection] = selections;
  const [map, setMap] = _react.default.useState(null);
  const [locationLatLng, setLocationLatLng] = _react.default.useState({
    lat: 37.7749,
    lng: -122.4194
  });
  const [userAddress, setUserAddress] = _react.default.useState(preselectedAddress);
  const [addressesSuggestionsList, setAddressesSuggestionsList] = _react.default.useState([]);
  const {
    replaceSelection,
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const detectUserLocation = map => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const loc = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        map.setCenter(loc);
        map.setZoom(14);
        setLocationLatLng(loc);
        handleGeocoderAddress(loc);
      }, () => {
        _logger.Logger.warn({
          segments: [_logger.Logger.LOGGER_SEGMENTS.LOCATION, _logger.Logger.LOGGER_SEGMENTS.QUESTIONNAIRE, _logger.Logger.LOGGER_SEGMENTS.COMPONENTS]
        })('Unable to access user location, blocked');
      });
    } else {
      _logger.Logger.warn({
        segments: [_logger.Logger.LOGGER_SEGMENTS.LOCATION, _logger.Logger.LOGGER_SEGMENTS.QUESTIONNAIRE, _logger.Logger.LOGGER_SEGMENTS.COMPONENTS]
      })("Unable to access user location, Browser doesn't support Geolocation");
    }
  };
  const handleUpdateAddressState = place => {
    const getAddressComponent = function () {
      var _place$address_compon, _place$address_compon2;
      for (var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++) {
        ids[_key] = arguments[_key];
      }
      const found = (_place$address_compon = place.address_components) === null || _place$address_compon === void 0 ? void 0 : (_place$address_compon2 = _place$address_compon.find(component => ids.some(id => component.types.includes(id)))) === null || _place$address_compon2 === void 0 ? void 0 : _place$address_compon2.long_name;
      return found !== null && found !== void 0 ? found : ' ';
    };
    setUserAddress(place.formatted_address);
    replaceSelection(JSON.stringify({
      id: place.place_id,
      href: place.place_id,
      name: place.formatted_address,
      city: getAddressComponent('administrative_area_level_2', 'administrative_area_level_1', 'administrative_area_level_3'),
      postcode: getAddressComponent('postal_code').replace(/\s/g, '') || ' ',
      locality: getAddressComponent('administrative_area_level_1', 'locality', 'country'),
      streetName: getAddressComponent('route', 'plus_code', 'administrative_area_level_4'),
      selectedStreetNr: getAddressComponent('street_number').trim() || '1|2|3'
      // latitude: parseFloat(place.geometry.location.lat()).toFixed(6),
      // longitude: parseFloat(place.geometry.location.lng()).toFixed(6),
    }));
  };

  // Function to handle custom suggestions based on user input
  const handleCustomSuggestions = inputValue => {
    setUserAddress(inputValue);
    const service = new google.maps.places.AutocompleteService();
    service.getQueryPredictions({
      input: inputValue
    }, (predictions, status) => {
      if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) return;
      setAddressesSuggestionsList(predictions.map(p => ({
        ...p,
        text: p.description
      })));
    });
  };
  const handleSelectSuggestedPlace = suggestion => {
    const placesService = new google.maps.places.PlacesService(map);
    placesService.getDetails({
      placeId: suggestion.place_id
    }, function (place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        if (!(place !== null && place !== void 0 && place.geometry)) return;
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        handleUpdateAddressState(place);
        setLocationLatLng({
          lat,
          lng
        });
        map.setCenter({
          lat,
          lng
        });
        map.setZoom(16);
      }
    });
  };
  const handleGeocoderAddress = _ref2 => {
    let {
      lat,
      lng
    } = _ref2;
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      location: {
        lat,
        lng
      }
    }, (results, status) => {
      if (status === 'OK' && results[0]) {
        handleUpdateAddressState(results[0]);
      } else if (selection) {
        removeSelection(selection);
      }
    });
  };
  const handleOnMapClick = e => {
    const pos = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    };
    setLocationLatLng(pos);
    map.setCenter(pos);
    handleGeocoderAddress(pos);
  };
  const handleMarkerDragEnd = e => {
    handleOnMapClick(e);
    handleGeocoderAddress({
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    });
  };
  const onLoad = _react.default.useCallback(function callback(map) {
    var _searchBoxRef$current;
    setMap(map);
    detectUserLocation(map);
    searchBoxRef === null || searchBoxRef === void 0 ? void 0 : (_searchBoxRef$current = searchBoxRef.current) === null || _searchBoxRef$current === void 0 ? void 0 : _searchBoxRef$current.focus();
  }, []);
  const onUnmount = _react.default.useCallback(function callback() {
    setMap(null);
  }, []);
  if (!isLoaded) return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    size: 1,
    text: "Initializing Map..."
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SearchSuggestionWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full',
      helpText: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
        name: "idea",
        size: 1
      }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, null, _services.Services.locale.localeString('Questionnaire.AddressSelectorTip')))
    },
    searchSuggestion: {
      domRef: searchBoxRef,
      suggestions: addressesSuggestionsList,
      value: userAddress,
      onChange: handleCustomSuggestions,
      handleFiltering: () => addressesSuggestionsList,
      type: 'text',
      id: 'address-search-map',
      placeholder: _services.Services.locale.localeString('Questionnaire.AddressSelectorPlaceholder'),
      onSelect: handleSelectSuggestedPlace,
      minCharacters: 2
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '400px',
      marginTop: '15px'
    }
  }, /*#__PURE__*/_react.default.createElement(_api.GoogleMap, {
    mapContainerStyle: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    options: {
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      gestureHandling: 'greedy',
      maxZoom: 20,
      minZoom: 2
    },
    zoom: 2,
    center: locationLatLng,
    onLoad: onLoad,
    onUnmount: onUnmount,
    onClick: handleOnMapClick
  }, /*#__PURE__*/_react.default.createElement(_api.MarkerF, {
    position: locationLatLng,
    draggable: true,
    onDragEnd: handleMarkerDragEnd
  }))));
}
var _default = /*#__PURE__*/_react.default.memo(SearchByMap);
exports.default = _default;